export default __webpack_public_path__ + "static/media/Investors-Meet-26.08.2026.3d5b0f21.pdf";